
//Auth module
import PrivateRoute from "./PrivateRoute";
import OpenRoute from "./OpenRoute";

// import external modules
import React, { Component } from "react";
import { Switch, Redirect } from "react-router-dom";

// Main Layout

import Vip from "pages/Vip";
import Landing from "pages/Landing";
import GamePlay from "pages/GamePlay";
import Terms from "pages/Terms";
import Privacy from "pages/Privacy";
import ResponsibleGaming from "pages/ResponsibleGaming";
import AMLPolicy from "pages/AMLPolicy";
import BonusTerms from "pages/BonusTerms";
import Profile from "pages/Profile";
import About from "pages/About";
import Contact from "pages/Contact";
import ContactDetails from "pages/ContactDetails";

import ResetPassword from "pages/auth/ResetPassword";
import Messages from "pages/Messages";

import Games from "pages/Games";
import Providers from "pages/Providers";
import ProviderGames from "pages/ProviderGames";
import BetHistory from "pages/players/BetHistory";
import AccountActivity from "pages/players/AccountActivity";
import Verify from "pages/players/Verify";

import Promotions from "pages/Promotions";
import Tournaments from "pages/Tournaments";
import Missions from "pages/Missions";
import Rewards from "pages/Rewards";
import Store from "pages/Store";
import FavoriteGames from "pages/FavoriteGames";
import Transactions from "pages/players/Transactions";
import Affiliates from "pages/Affiliates";
import UserDashboard from "pages/UserDashboard";
import Wheel from "pages/Wheel";

// const Landing = lazy(() => import("../pages/Landing"));
// import { BrowserRouter, Switch, Redirect } from "react-router-dom";
class OpenRoutes extends Component {
  // const history = useHistory()
  //   useEffect(() => {
  //     const unlisten = history.listen((location, action) => {
  //       if (action !== 'POP') {
  //         window.scrollTo(0, 0)
  //       {
  //     })
  //     return () => unlisten()
  //   }, [])

  render() {
    return (
        <Switch>
          {/* Auth pages route */}
          {/*
            Logged-out users always land on Landing, even in PWA mode. Home
            triggers auth-required API calls (CategoryGames -> /games/by-category)
            that return 401 for guests and loop the "Unauthorized" alert. The PWA
            onboarding overlay is rendered on top of Landing by FullLayout. Home is
            only used as the PWA homepage for authenticated users (PrivateRoutes).
          */}
          <OpenRoute exact path="/" component={Landing}></OpenRoute>
          <OpenRoute
            exact
            path="/social/auth/response/google/"
            component={Landing}
          ></OpenRoute>
          <OpenRoute
            exact
            path="/tournaments"
            component={Tournaments}
          ></OpenRoute>
          <OpenRoute exact path="/missions" component={Missions}></OpenRoute>
          <OpenRoute exact path="/rewards" component={Rewards}></OpenRoute>
          <OpenRoute exact path="/store" component={Store}></OpenRoute>
          <OpenRoute
            exact
            path="/play/:slug"
            component={GamePlay}
          ></OpenRoute>
          <OpenRoute
            exact
            path="/terms-and-conditions"
            component={Terms}
          ></OpenRoute>
          <OpenRoute
            exact
            path="/privacy-policy"
            component={Privacy}
          ></OpenRoute>
          <OpenRoute exact path="/affiliates" component={Affiliates} />
          <OpenRoute exact path="/about-us" component={About}></OpenRoute>
          <OpenRoute exact path="/contact-us" component={Contact}></OpenRoute>
          <OpenRoute
            exact
            path="/contact-details"
            component={ContactDetails}
          ></OpenRoute>
          {/* /loyalty-program is the same feature as /vip ("VIP & Loyalty
              Program"); the old page was an unfinished duplicate. Redirect so
              existing links keep working and the SEO consolidates on /vip. */}
          <Redirect exact from="/loyalty-program" to="/vip" />

          <OpenRoute exact path="/vip" component={Vip}></OpenRoute>

          <OpenRoute exact path="/login" component={Landing}></OpenRoute>
          <OpenRoute exact path="/register" component={Landing}></OpenRoute>
          <OpenRoute
            exact
            path="/recover-password"
            component={Landing}
          ></OpenRoute>
          <OpenRoute
            exact
            path="/reset-password/:userId/:code"
            component={ResetPassword}
          ></OpenRoute>

          <OpenRoute exact path="/home" component={Landing}></OpenRoute>
          <OpenRoute exact path="/wheel" component={Wheel}></OpenRoute>

          <OpenRoute
            exact
            path="/games/:gameType"
            component={Games}
          ></OpenRoute>
          <OpenRoute exact path="/providers" component={Providers}></OpenRoute>
          <OpenRoute
            exact
            path="/providers/:slug"
            component={ProviderGames}
          ></OpenRoute>
          {/* <OpenRoute exact path="/games/:slots" component={Games}></OpenRoute>
          <OpenRoute exact path="/games/:jackpot" component={Jackpot}></OpenRoute>
          <OpenRoute
            exact
            path="/games/:table-games"
            component={TableGames}
          ></OpenRoute> */}

          <OpenRoute exact path="/profile" component={Profile}></OpenRoute>
          <OpenRoute
            exact
            path="/promotions"
            component={Promotions}
          ></OpenRoute>
          {
            // <OpenRoute exact path="/terms" component={Terms}></OpenRoute>
            // <OpenRoute exact path="/privacy" component={Privacy}></OpenRoute>
            // <OpenRoute exact path="/responsible-gaming" component={ResponsibleGaming}></OpenRoute>
          }
          <OpenRoute exact path="/responsible-gaming" component={ResponsibleGaming}></OpenRoute>
          <OpenRoute exact path="/aml-policy" component={AMLPolicy}></OpenRoute>
          <OpenRoute exact path="/bonus-terms" component={BonusTerms}></OpenRoute>

          <Redirect path="*" to="/" />
        </Switch>
    );
  }
}

class PrivateRoutes extends Component {
  render() {
    return (
        <Switch>
          {/*Employee routing*/}
          {/*
            Both web and PWA use the styled Landing page as the logged-in
            homepage. The legacy Home page is unstyled (no play365 theme) and
            only reachable via the explicit /home route.
          */}
          <PrivateRoute exact path="/" component={Landing}></PrivateRoute>
          <PrivateRoute
            exact
            path="/social/auth/response/google/"
            component={Landing}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/payment-status/:status?"
            component={Landing}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/play/:slug"
            component={GamePlay}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/terms-and-conditions"
            component={Terms}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/privacy-policy"
            component={Privacy}
          ></PrivateRoute>
          <PrivateRoute exact path="/about-us" component={About}></PrivateRoute>
          <PrivateRoute
            exact
            path="/contact-us"
            component={Contact}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/contact-details"
            component={ContactDetails}
          ></PrivateRoute>
          {/* /redeem + /redeem-rules were the sweepstakes redemption flow
              (SC balance, play-once-before-redeem, min 100 SC). GoldenClover is
              real-money: withdrawals run through the cashier (CashierModals).
              Nothing linked here; the routes are removed rather than rebuilt. */}
          <PrivateRoute exact path="/affiliates" component={Affiliates} />
          <PrivateRoute exact path="/home" component={Landing}></PrivateRoute>

         

          <PrivateRoute
            exact
            path="/games/:gameType"
            component={Games}
          ></PrivateRoute>
          <PrivateRoute exact path="/providers" component={Providers}></PrivateRoute>
          <PrivateRoute
            exact
            path="/providers/:slug"
            component={ProviderGames}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/favorite-games"
            component={FavoriteGames}
          ></PrivateRoute>
          <Redirect exact from="/loyalty-program" to="/vip" />
          <PrivateRoute exact path="/vip" component={Vip}></PrivateRoute>
          <PrivateRoute exact path="/missions" component={Missions}></PrivateRoute>
          <PrivateRoute exact path="/rewards" component={Rewards}></PrivateRoute>
          <PrivateRoute exact path="/store" component={Store}></PrivateRoute>
          <PrivateRoute exact path="/wheel" component={Wheel}></PrivateRoute>
          {/* <PrivateRoute
            exact
            path="/games/:gameType"
            component={Jackpot}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/games/:gameType"
            component={TableGames}
          ></PrivateRoute> */}
          <PrivateRoute
            exact
            path={"/dashboard/:tab?"}
            component={UserDashboard}
          ></PrivateRoute>

          <PrivateRoute
            exact
            path="/profile"
            component={Profile}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/gameplay-history"
            component={BetHistory}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/history"
            component={Transactions}
          ></PrivateRoute>

          <PrivateRoute
            exact
            path="/account-activity"
            component={AccountActivity}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/account-verification"
            component={Verify}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/messages"
            component={Messages}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path="/promotions"
            component={Promotions}
          ></PrivateRoute>
          <PrivateRoute exact path="/responsible-gaming" component={ResponsibleGaming}></PrivateRoute>
          <PrivateRoute exact path="/aml-policy" component={AMLPolicy}></PrivateRoute>
          <PrivateRoute exact path="/bonus-terms" component={BonusTerms}></PrivateRoute>
          <Redirect path="*" to="/" />
        </Switch>
    );
  }
}

export { OpenRoutes, PrivateRoutes };
